<template>
  <v-container class="wrapper-ticket-message pa-0" :class="{ '': isTicketSelected }">
    <MessageList
      :stopLoading="stopLoading"
      :messages="messages"
      :isTicketSelected="isTicketSelected"
      :selectedTicket="selectedTicket"
      @fileAttach="fileAttachHandler"
      @submit="submitMessage"
      :isCreateNewTicket="isCreateNewTicket"
      @closeTicket="closeTicket"
      @ticketError="onTicketError"
      @ticketStatusChanged="$emit('ticketStatusChanged')"
      @onSelectedDepartment="selectedDepartmentHandler"
      @openTicketConversation="$emit('openTicketConversation', $event)"
      :toggleSelectionTicket="toggleSelectionTicket"
      :isMessageSend="isMessageSend"
      :loading="loading"
    />
    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import General from "../../../../../Mixins/general";
import MessageList from "@/views/dashboard/pages/ticket/partial/message/MessageList.vue";

export default {
  props: {
    isTicketSelected: Boolean,
    selectedTicket: Object,
    isCreateNewTicket: Boolean,
    toggleSelectionTicket: Boolean,
  },
  mixins: [General],
  data() {
    return {
      currentPage: 1,
      messages: [],
      ticketId: null,
      newTicket: null,
      files: null,
      selectedDepartmentId: null,
      isMessageSend: false,
      loading: false,
      stopLoading: false,
      intervalId: null,
    };
  },
  components: {
    MessageList,
  },
  methods: {
    fetchTicketMessages() {
      // const existingIds = new Set(this.meessages.map(msg => msg.id))
      var app = this;
      app.$axios
        .get(this.$endpoint + "ticketMessage", {
          params: {
            page: this.currentPage,
            options: JSON.stringify({ page: this.currentPage, itemsPerPage: 100 }),
            search: null,
            ticket_id: this.ticketId,
          },
        })
        .then((r) => {
          this.isMessageSend = !this.isMessageSend;
          // const newMessages = r.data.data.filter(msg => !existingIds.has(msg.id))
          this.messages = r.data.data.reverse();
        })
        .catch((e) => {
          console.error("Error:", e);
        });
    },
    fileAttachHandler(value) {
      this.files = value && value.length ? [...value] : [];
    },
    submitTicket(data) {
      var app = this;
      app.$axios
        .post(this.$endpoint + "ticketing", {
          department_id: this.selectedDepartmentId,
          title: data.ticketTitle != null ? data.ticketTitle : "new ticket",
          content: data.value.body ? data.value.body : "",
        })
        .then((r) => {
          this.newTicket = r.data.data;
          this.$emit("addTickets", this.newTicket);
          this.ticketId = r.data.data.id;
          this.submitMessage(data);
        })
        .catch((e) => {
          console.error("Error:", e);
        });
    },
    handleSizeFile() {
      if (!this.files || this.files.length === 0) {
        return false;
      }
      const maxSize = 1 * 1024 * 1024;
      return this.files.some((file) => file.size > maxSize);
    },
    submitMessage(data) {
      const checkingFileSize = this.handleSizeFile();
      if (checkingFileSize) {
        this.stopLoading = !this.stopLoading;
        this.snakbarText = this.$t("File size must be less than 1 MB");
        this.snakbarColor = "pink";
        this.snakbar = true;
        return;
      }
      if (this.ticketId != null) {
        this.finallySubmitMassage(data);
      } else {
        this.submitTicket(data);
      }
    },
    finallySubmitMassage(data) {
      var app = this;
      app.$axios
        .post(this.$endpoint + "ticketMessage", {
          ticket_id: this.ticketId,
          message: data.value.body ? data.value.body : "no caption",
        })
        .then((r) => {
          // 1. sending sipmle (text)
          if (data.value.type == "text") {
            this.fetchTicketMessages();
            this.files = [];
          }
          // 2. sending (file + text)
          if (data.value.type == "text/file") {
            const formData = new FormData();
            formData.append("select", "fileUpload");
            formData.append("type", "ticket");
            formData.append("refId", r.data.data.id);
            this.files.forEach((file, index) => {
              formData.append(`file[${index}]`, file);
            });

            var app = this;
            app.$axios
              .post(this.$endpoint + "createdetail", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((r) => {
                this.fetchTicketMessages();
                this.files = [];
              })
              .catch((e) => {
                this.stopLoading = !this.stopLoading;
                this.serverErrorHandeler(e);
              });
          }
        })
        .catch((e) => {
          this.stopLoading = !this.stopLoading;
          this.serverErrorHandeler(e);
        });
    },
    fetchMessagesSpTicket() {
      // const existingIds = new Set(this.meessages.map(msg => msg.id))
      this.loading = true;
      var app = this;
      app.$axios
        .get(this.$endpoint + "ticketMessage", {
          params: {
            page: this.currentPage,
            options: JSON.stringify({ page: this.currentPage, itemsPerPage: 100 }),
            search: null,
            ticket_id: this.ticketId,
          },
        })
        .then((r) => {
          this.loading = false;
          // const newMessages = r.data.data.filter(msg => !existingIds.has(msg.id))
          this.messages = r.data.data.reverse();
        })
        .catch((e) => {
          console.error("Error:", e);
        });
    },
    selectedDepartmentHandler(val) {
      this.selectedDepartmentId = val;
    },
    ticketStatusChanged() {
      this.$emit("ticketStatusChanged");
    },
    closeTicket(value) {
      this.$emit("closeTicket", value);
    },
    onTicketError(e) {
      this.serverErrorHandeler(e);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  watch: {
    selectedTicket(val) {
      if (val && val != null) {
        this.ticketId = val.id;
        this.fetchMessagesSpTicket();
      }
    },
    isCreateNewTicket(val) {
      this.ticketId = null;
      this.messages = [];
    },
  },
};
</script>
